import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../services/student-authentication.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const authenticationService = inject(AuthenticationService);
    const snackBar = inject(MatSnackBar);

    const { idToken, accessToken } = authenticationService;

    if (idToken && !/user\/([\s\S])*/.test(req.url) && !urlRequiresAccessToken(req.url) && !/verify\//.test(req.url)) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${idToken}`,
            },
        });
    }

    if (accessToken && urlRequiresAccessToken(req.url)) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }

    return next(req).pipe(
        catchError((err) => {
            if (err.status === 401 && !err.url.endsWith('user/login') && !err.url.includes('/verify/')) {
                authenticationService.removeTokens();
                location.reload();
            } else if (err.status === 500 || err.status === 503) {
                snackBar.open('Something went wrong', 'Close', {
                    duration: 8000,
                    panelClass: ['fail-snackbar'],
                });
            } else if (err.status === 429) {
                snackBar.open(
                    'The system is currently experiencing high usage. Please wait a few minutes and try again.',
                    'Close',
                    {
                        duration: 8000,
                        panelClass: ['fail-snackbar'],
                    }
                );
            }
            return throwError(() => err);
        })
    );
};

function urlRequiresAccessToken(url: string): boolean {
    return /user\/logout/.test(url)
        || /user\/verify-email/.test(url)
        || /user\/resend-confirmed-code/.test(url)
        || /student\/update-email/.test(url);
}
